import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';

const stats = [
  { label: '漫画总量', value: '12万+', icon: 'ri-book-2-line' },
  { label: '日活跃用户', value: '50万+', icon: 'ri-user-heart-line' },
  { label: '月更新话数', value: '3万+', icon: 'ri-refresh-line' },
  { label: '用户好评率', value: '98.6%', icon: 'ri-thumb-up-line' },
];

const reviews = [
  {
    name: '小明同学',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20stylized%20anime%20avatar%20of%20a%20young%20Chinese%20boy%20with%20short%20black%20hair%2C%20friendly%20smile%2C%20warm%20expression%2C%20minimalist%20flat%20design%20on%20light%20background&width=100&height=100&seq=avatar-user-01&orientation=squarish',
    rating: 5,
    content: '可乐漫画真的是我见过的最好用的漫画网站！漫画资源特别全，画质也很清晰，关键是完全免费，太良心了！强烈推荐给所有喜欢看漫画的朋友！',
    date: '2026-07-28',
  },
  {
    name: '漫迷小美',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20stylized%20anime%20avatar%20of%20a%20young%20Chinese%20girl%20with%20long%20dark%20hair%2C%20gentle%20smile%2C%20bright%20eyes%2C%20minimalist%20flat%20design%20on%20light%20background&width=100&height=100&seq=avatar-user-02&orientation=squarish',
    rating: 5,
    content: '韩漫分类特别细致，找漫画超级方便！每天都会来刷更新，更新速度很快，基本上官方更新了这里就有了。阅读体验也很流畅，点赞！',
    date: '2026-07-25',
  },
  {
    name: '二次元老司机',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20stylized%20anime%20avatar%20of%20a%20young%20man%20with%20glasses%20and%20slightly%20messy%20hair%2C%20confident%20expression%2C%20minimalist%20flat%20design%20on%20light%20background&width=100&height=100&seq=avatar-user-03&orientation=squarish',
    rating: 5,
    content: '从学生时代就喜欢看漫画，用过很多网站，可乐漫画是体验最好的。没有烦人的弹窗广告，页面干净整洁，漫画分类也很科学。国漫频道越来越丰富，支持！',
    date: '2026-07-20',
  },
  {
    name: '追漫达人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20stylized%20anime%20avatar%20of%20a%20young%20woman%20with%20short%20bob%20haircut%2C%20energetic%20expression%2C%20warm%20smile%2C%20minimalist%20flat%20design%20on%20light%20background&width=100&height=100&seq=avatar-user-04&orientation=squarish',
    rating: 4,
    content: '日漫资源非常全，经典老番和新番都有！页面响应速度也快，下拉式阅读体验真的很棒。唯一的期望是能快点加上搜索功能，那就更完美了！',
    date: '2026-07-18',
  },
];

const teamMembers = [
  {
    name: '可乐',
    role: '创始人 & CEO',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20professional%20portrait%20of%20a%20young%20Chinese%20man%20in%20casual%20business%20attire%2C%20warm%20and%20approachable%2C%20modern%20office%20background%2C%20minimalist%20illustration%20style%2C%20clean%20and%20professional&width=300&height=300&seq=team-ceo-01&orientation=squarish',
    desc: '十年漫画爱好者，梦想打造最好的中文漫画平台',
  },
  {
    name: '小雪',
    role: '内容主编',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20professional%20portrait%20of%20a%20young%20Chinese%20woman%20with%20glasses%2C%20creative%20and%20thoughtful%20expression%2C%20surrounded%20by%20books%2C%20minimalist%20illustration%20style%2C%20clean%20and%20professional&width=300&height=300&seq=team-editor-01&orientation=squarish',
    desc: '资深漫画编辑，对漫画内容品质有着极高的追求',
  },
  {
    name: '大鹏',
    role: '技术负责人',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20professional%20portrait%20of%20a%20young%20Chinese%20man%20in%20a%20hoodie%2C%20focused%20and%20innovative%2C%20with%20computer%20in%20background%2C%20minimalist%20illustration%20style%2C%20clean%20and%20professional&width=300&height=300&seq=team-cto-01&orientation=squarish',
    desc: '全栈工程师，确保每一位读者都能获得流畅的阅读体验',
  },
];

export default function AboutPage() {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formError, setFormError] = useState('');
  const [formSubmitting, setFormSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('input[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormSubmitted(true);
      setFormError('');
      return;
    }
    setFormSubmitting(true);
    setFormError('');

    const formData = new FormData(form);
    try {
      const res = await fetch('https://readdy.ai/api/form/d9oo7sqftmtnfcfh0au0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      if (res.ok && parsed?.code === 'OK') {
        setFormSubmitted(true);
        setFormError('');
        form.reset();
      } else {
        setFormError(serverMsg || '提交失败，请稍后再试');
      }
    } catch {
      setFormError('网络错误，请检查您的网络连接');
    } finally {
      setFormSubmitting(false);
    }
  };

  return (
    <>
      <SEOHead
        title="关于我们 - 可乐漫画 | 品牌介绍与联系方式"
        description="可乐漫画——按类型精选韩漫、日漫、国漫，好看的漫画大全一网打尽。了解我们的品牌故事、团队介绍以及联系方式，为您提供最优质的漫画阅读服务。"
        keywords="可乐漫画, 关于我们, 漫画平台, 联系我们, 品牌介绍, 漫画阅读"
        canonicalUrl="https://kelecomic.com/about"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          name: '关于可乐漫画',
          description: '可乐漫画——按类型精选韩漫、日漫、国漫，好看的漫画大全一网打尽，热门漫画免费在线看',
          about: {
            '@type': 'Organization',
            name: '可乐漫画',
            foundingDate: '2022-06-01',
            description: '可乐漫画是一个专注于提供高质量漫画阅读体验的在线平台',
          },
        }}
      />
      <ScrollToTop />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-16">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 pt-6">
            <Breadcrumb />

            {/* Hero */}
            <section className="py-10 md:py-16 text-center">
              <h1 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-4">关于可乐漫画</h1>
              <p className="text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                可乐漫画成立于2022年，是一个专注于提供高质量漫画阅读体验的在线平台。我们汇聚了韩漫、日漫、国漫等丰富的漫画资源，致力于为每一位漫画爱好者提供流畅、免费、高品质的在线阅读服务。
              </p>
            </section>

            {/* Stats */}
            <section className="py-8 md:py-12">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
                {stats.map((stat) => (
                  <div key={stat.label} className="text-center p-6 rounded-xl bg-background-100">
                    <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-3">
                      <i className={`${stat.icon} text-xl`}></i>
                    </div>
                    <p className="text-2xl md:text-3xl font-heading text-foreground-900">{stat.value}</p>
                    <p className="text-sm text-foreground-500 mt-1">{stat.label}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* Brand Story */}
            <section className="py-10 md:py-14">
              <h2 className="text-2xl font-heading text-foreground-900 mb-6 text-center">品牌故事</h2>
              <div className="max-w-3xl mx-auto bg-background-100 rounded-2xl p-6 md:p-10">
                <p className="text-foreground-600 leading-relaxed mb-4">
                  可乐漫画的诞生源于创始人对漫画的热爱。作为一个从小看着漫画长大的"老漫迷"，创始人"可乐"深知找一部好看的漫画有多难——要么资源不全、要么广告满天飞、要么画质模糊。
                </p>
                <p className="text-foreground-600 leading-relaxed mb-4">
                  于是，2022年夏天，可乐漫画正式上线。我们的初心很简单：<strong>做一个真正为漫画爱好者服务的平台</strong>。不收费、不弹窗、高清画质、流畅阅读——这是我们对每一位用户的承诺。
                </p>
                <p className="text-foreground-600 leading-relaxed">
                  如今，可乐漫画已经汇聚了超过12万部漫画作品，每天有超过50万漫画爱好者在这里找到他们喜欢的作品。从韩漫的热血逆袭到日漫的经典传承，从国漫的国风美学到各类小众佳作的发掘，我们一直在努力让更多人感受到漫画的魅力。
                </p>
              </div>
            </section>

            {/* Team */}
            <section className="py-10 md:py-14 bg-background-100 -mx-4 md:-mx-6 px-4 md:px-6">
              <div className="max-w-[1400px] mx-auto">
                <h2 className="text-2xl font-heading text-foreground-900 mb-6 text-center">核心团队</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-4xl mx-auto">
                  {teamMembers.map((member) => (
                    <div key={member.name} className="text-center p-6 rounded-xl bg-background-50">
                      <div className="w-24 h-24 mx-auto rounded-full overflow-hidden mb-4">
                        <img src={member.image} alt={member.name} className="w-full h-full object-cover" />
                      </div>
                      <h3 className="font-semibold text-foreground-900">{member.name}</h3>
                      <p className="text-xs text-primary-500 font-medium mt-0.5">{member.role}</p>
                      <p className="text-sm text-foreground-500 mt-2">{member.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* Reviews */}
            <section className="py-10 md:py-14">
              <h2 className="text-2xl font-heading text-foreground-900 mb-6 text-center">用户口碑</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-4xl mx-auto">
                {reviews.map((review) => (
                  <div key={review.name} className="p-5 rounded-xl bg-background-100">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                        <img src={review.avatar} alt={review.name} className="w-full h-full object-cover" />
                      </div>
                      <div>
                        <p className="text-sm font-semibold text-foreground-900">{review.name}</p>
                        <div className="flex items-center gap-0.5 mt-0.5">
                          {Array.from({ length: 5 }, (_, i) => (
                            <div key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                              <i className={`ri-star-fill text-xs ${i < review.rating ? 'text-accent-500' : 'text-foreground-300'}`}></i>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">{review.content}</p>
                    <p className="text-xs text-foreground-400 mt-3">{review.date}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* Contact */}
            <section id="contact" className="py-10 md:py-14 bg-background-100 -mx-4 md:-mx-6 px-4 md:px-6">
              <div className="max-w-[1400px] mx-auto">
                <h2 className="text-2xl font-heading text-foreground-900 mb-6 text-center">联系我们</h2>
                <div className="max-w-2xl mx-auto">
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
                    <div className="text-center p-5 rounded-xl bg-background-50">
                      <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-3">
                        <i className="ri-mail-line text-lg"></i>
                      </div>
                      <p className="text-sm font-medium text-foreground-900">电子邮箱</p>
                      <p className="text-xs text-foreground-500 mt-1">contact@kelecomic.com</p>
                    </div>
                    <div className="text-center p-5 rounded-xl bg-background-50">
                      <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mb-3">
                        <i className="ri-wechat-line text-lg"></i>
                      </div>
                      <p className="text-sm font-medium text-foreground-900">微信公众号</p>
                      <p className="text-xs text-foreground-500 mt-1">可乐漫画</p>
                    </div>
                    <div className="text-center p-5 rounded-xl bg-background-50">
                      <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 mb-3">
                        <i className="ri-weibo-line text-lg"></i>
                      </div>
                      <p className="text-sm font-medium text-foreground-900">官方微博</p>
                      <p className="text-xs text-foreground-500 mt-1">@可乐漫画官方</p>
                    </div>
                  </div>

                  <div className="bg-background-50 rounded-2xl p-6 md:p-8">
                    <h3 className="text-lg font-heading text-foreground-900 mb-4">发送消息</h3>

                    {formSubmitted ? (
                      <div className="text-center py-8">
                        <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mb-3">
                          <i className="ri-check-line text-2xl"></i>
                        </div>
                        <p className="text-foreground-900 font-medium">消息发送成功！</p>
                        <p className="text-sm text-foreground-500 mt-1">感谢您的来信，我们会尽快回复。</p>
                      </div>
                    ) : (
                      <form onSubmit={handleSubmit} data-readdy-form className="space-y-4">
                        {formError && (
                          <div className="p-3 rounded-lg bg-primary-100 text-primary-700 text-sm">{formError}</div>
                        )}
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                          <div>
                            <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                            <input type="text" id="name" name="name" required className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-white text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors" placeholder="请输入您的姓名" />
                          </div>
                          <div>
                            <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                            <input type="email" id="email" name="email" required className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-white text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors" placeholder="请输入您的邮箱" />
                          </div>
                        </div>
                        <div>
                          <label htmlFor="subject" className="block text-sm font-medium text-foreground-700 mb-1.5">主题</label>
                          <input type="text" id="subject" name="subject" required className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-white text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors" placeholder="请输入消息主题" />
                        </div>
                        <div>
                          <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1.5">消息内容</label>
                          <textarea id="message" name="message" rows={4} maxLength={500} required className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-white text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none" placeholder="请输入您的消息（最多500字）" />
                          <p className="text-xs text-foreground-400 mt-1">最多输入500个字符</p>
                        </div>
                        <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                        <button type="submit" disabled={formSubmitting} className="w-full sm:w-auto px-8 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm transition-all cursor-pointer disabled:opacity-50 whitespace-nowrap">
                          {formSubmitting ? '发送中...' : '发送消息'}
                        </button>
                      </form>
                    )}
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}